import { logNotification } from './OTelNotifications';
import { TelemetryProperties, LogLevel, Category } from './DataModels';

const NAMESPACE_SEPARATOR = '.';

let tenantTokens: { [namespace: string]: TelemetryProperties } = {};

export function setTenantTokens(namespace: string, telemetryProperties: TelemetryProperties) {
  if (
    // Starts with "Office." and doesn't end with "."
    namespace.substring(0, 7) === 'Office' + NAMESPACE_SEPARATOR &&
    namespace[namespace.length - 1] !== NAMESPACE_SEPARATOR
  ) {
    tenantTokens[namespace] = telemetryProperties;
  } else {
    logNotification(LogLevel.Error, Category.Core, () => {
      return `Namespace: ${namespace}`;
    });
    return;
  }
}

/**
 * Gets the tenant tokens corresponding to an event
 * Strategy: Search for the whole string, then substrings that could be the namespace
 * @param eventName - The event name
 * @returns - The corresponding tenant tokens, or undefined if none found
 */
export function getTenantTokens(eventName: string) {
  let indexOfCharacterAfterNamespace = eventName.length;
  while (indexOfCharacterAfterNamespace > 0) {
    const namespaceCandidate = eventName.substr(0, indexOfCharacterAfterNamespace);
    if (tenantTokens[namespaceCandidate]) {
      return tenantTokens[namespaceCandidate];
    }
    indexOfCharacterAfterNamespace = eventName.lastIndexOf(NAMESPACE_SEPARATOR, indexOfCharacterAfterNamespace - 1);
  }
  return undefined;
}

export function clear() {
  tenantTokens = {};
}
